"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _maxSafeInteger = require("babel-runtime/core-js/number/max-safe-integer");

var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocationDeriver = function () {
  function LocationDeriver() {
    (0, _classCallCheck3.default)(this, LocationDeriver);
  }

  (0, _createClass3.default)(LocationDeriver, null, [{
    key: "groupByParent",
    value: function groupByParent(locations) {
      return locations.reduce(function (result, location) {
        if (result[location.parent_id]) {
          result[location.parent_id].children.push(location);
        } else {
          result[location.parent_id] = {
            id: location.parent_id,
            name: location.parent_name,
            position: location.parent_position !== undefined ? location.parent_position : _maxSafeInteger2.default,
            children: [location]
          };
        }

        return result;
      }, []).sort(function (a, b) {
        return a.position > b.position;
      });
    }
  }, {
    key: "addressRequirements",
    value: function addressRequirements(data) {
      return {
        address1: data.address_fields.address_line_1,
        address2: data.address_fields.address_line_2,
        city: data.address_fields.city,
        postalCode: data.address_fields.postal_code,
        state: data.address_fields.state_code
      };
    }
  }]);
  return LocationDeriver;
}();

exports.default = LocationDeriver;